import { SimpleGrid, Box } from "@chakra-ui/react";
import projects from "../../files/projects.json";
import { ProjectCard } from "./ProjectCard";

export const ProjectGrid = () => (
  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w="full">
    {projects.map((project) => (
      <Box key={project.id}>
        <ProjectCard project={project} />
      </Box>
    ))}
  </SimpleGrid>
);

export const ProjectGridSingle = () => (
  <SimpleGrid columns={1} spacing={6} w="full">
    {projects.map((project) => (
      <Box key={project.id}>
        <ProjectCard project={project} />
      </Box>
    ))}
  </SimpleGrid>
);
